export default __webpack_public_path__ + "static/1-f9f65757eae14f787b0056241b950712.png";